import React, { useEffect, useRef } from 'react';

import styles from './index.module.scss';
import { useKeyListener } from '@navi/web-ui/lib/hooks';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { CloseIcon } from '@navi/web-ui/lib/icons';

import cx from 'classnames';
import { ESCAPE_KEY } from '@navi/web-ui/lib/constants/Components';

interface IOverlay extends React.PropsWithChildren {
  visible: boolean;
  containerClasses?: string;
  header?: string;
  onClose: () => void;
  headerColor?: string;
  headerClassName?: string;
  contentClassName?: string;
  iconButtonSize?: number;
  isHeaderRequired?: boolean;
}

const ExpandedView: React.FC<IOverlay> = props => {
  const {
    children,
    visible,
    containerClasses,
    header,
    onClose,
    headerColor,
    headerClassName,
    contentClassName,
    iconButtonSize = 18,
    isHeaderRequired = true
  } = props;
  const overlayRef = useRef<HTMLDivElement>(null);

  // Close expand on ESC key press
  useKeyListener(ESCAPE_KEY, onClose, visible);

  return (
    <>
      {visible && (
        <div className={cx(styles.overlay, containerClasses)}>
          <div ref={overlayRef} className={styles.contentWrapper}>
            {isHeaderRequired ? (
              <div className={cx(styles.header, headerClassName)}>
                <Typography variant={'h3'} color={headerColor}>
                  {header || ''}
                </Typography>
                <Button onClick={onClose}>
                  <CloseIcon width={iconButtonSize} height={iconButtonSize} />
                </Button>
              </div>
            ) : null}
            <div className={cx(styles.content, contentClassName)}>{children}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpandedView;
